import type { AnnouncementItemProperties } from './AnnouncementItem.types'
import AnnouncementItemCard from './AnnouncementItemCard'
import AnnouncementItemDetail from './AnnouncementItemDetail'

const AnnouncementItem: AnnouncementItemProperties = () => null

AnnouncementItem.Card = AnnouncementItemCard
AnnouncementItem.Detail = AnnouncementItemDetail

export default AnnouncementItem
